import AuthenticatedResource from 'resources/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class PublicFormResponseDetailResource extends AuthenticatedResource {
  static urlRoot = '/organization/:organization/public_form_instances';

  id                = undefined;
  public_form_id    = undefined;
  client_form_id    = undefined;
  completed_at      = null;
  created_at        = null;
  updated_at        = null;
  answers           = null;

  pk() {
    return this.id && this.id.toString();
  }
}
